export enum ProjectStatus {
  Unassigned,
  ToDo,
  InProgress,
  Done
}
